import FlexPane from './_flex-pane.js'
import PartView from './_part-view.js'
import Text from './_text.js'
import ChangedValueIndicator from './_changed-value-indicator.js'
import Image from './_image.js'
import DateTime from './_date-time.js'
import EarlyPayoutIndicator from './_early-payout-indicator.js'
import OddsBoostNotification from './_odds-boost-notification.js'
import MatchAccaSelectionItem from './_match-acca-selection-item.js'

export default {
  name: 'LegView',
  values: {
    container: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
        },
      },
    },
    infoContainer: {
      configSet: FlexPane,
      configValues: {},
    },
    selectionInfoContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          flexBasis: '0px',
          padding: '0 8px 8px 8px',
        },
      },
    },
    part: {
      configSet: PartView,
      configValues: {},
    },
    multicastContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          flexDirection: 'column',
        },
      },
    },
    multicastSelectionName: {
      configSet: Text,
      configValues: {},
    },
    multicastMarketName: {
      configSet: Text,
      configValues: {},
    },
    eventName: {
      configSet: Text,
      configValues: {
        container: {
          padding: '4px 0 0 0',
        },
        style: {
          lineHeight: '16px',
        },
      },
    },
    matchAccaHeader: {
      configSet: Text,
      configValues: {},
    },
    oddsInfoContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          flexShrink: 0,
          flexGrow: 0,
          flexBasis: 'auto',
          alignItems: 'flex-start',
          padding: '0 0 0 8px',
        },
      },
    },
    odds: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: 0,
        },
        style: {
          lineHeight: '16px',
        },
      },
    },
    priceBoostIndicator: {
      configSet: ChangedValueIndicator,
      configValues: {
        container: {
          style: {
            alignItems: 'center',
          },
        },
        indicationIcon: {
          src: 'double-arrow-right',
          style: {
            minWidth: '12px',
            minHeight: '12px',
          },
        },
      },
    },
    bestOddsIcon: {
      configSet: Image,
      configValues: {
        src: 'racing-bestodds',
        style: {
          minWidth: '16px',
          minHeight: '16px',
        },
      },
    },
    eventNameTimeFormat: {
      configSet: DateTime,
      configValues: {
        format: 'SHORT_TIME',
      },
    },
    changedOddsIndicator: {
      configSet: ChangedValueIndicator,
      configValues: {},
    },
    notificationContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          padding: '4px 0 0 0',
          flexWrap: 'wrap',
        },
      },
    },
    earlyPayoutIndicator: {
      configSet: EarlyPayoutIndicator,
      configValues: {},
    },
    oddsBoostNotification: {
      configSet: OddsBoostNotification,
      configValues: {},
    },
    matchAccaOddsBoostNotification: {
      configSet: OddsBoostNotification,
      configValues: {
        container: {
          style: {
            padding: '4px 0',
          },
        },
      },
    },
    matchAccaSelectionItem: {
      configSet: MatchAccaSelectionItem,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
